<style scoped>
.loader-block {
  padding-top: 150px;
}

.history-statuses p {
  margin: 0 10px
}

.aquazor-no-data {
    text-align: center;
    margin-top: 100px;
}
</style>

<template>
<div class="col-12 history-statuses">
  <div class="table">
    <div class="table_row" v-for="(row_data, index) in view_slice" :key="index">
      <div class="table_cell">{{getDateTime(row_data[4])}}</div>
      <div class="table_cell">
        <p class="alert-status" :class="{'alert-status': isAlarm(row_data[2]), 'norm-status': !isAlarm(row_data[2])}">{{getStatusText(row_data)}}</p>
      </div>
    </div>
  </div>
  <div class="col-12 aquazor-pagination-block" v-if="this.dataset.length > 0">
    <paginate-component :totalItems="total_items" :max-visible-pages="6" :page="pagination_index" :itemsPerPage="count_view_rows" v-on:page-change="changePagination" v-if="!loader"></paginate-component>
  </div>
  <div class="col-12 aquazor-no-data" v-if="this.dataset.length == 0 && !loader">
      <p>Нет данных</p>
  </div>
  <div class="loader-block" v-if="loader">
    <loader-component></loader-component>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import loader from './loader.vue'
import vuePaginate from 'vue-ads-pagination'
import '@/assets/css/aquazor-pagination.css'

export default {
  created() {
    get_for_history(this)
  },
  components: {
    'loader-component': loader,
    'paginate-component': vuePaginate
  },
  data() {
    return {
      loader: true,
      sensors: {},
      faucets: {},
      dataset: [],
      pagination_index: 0,
      count_view_rows: 50,
      pagination_total: 1,
      view_slice: [],
      utc_difference: get_utc_difference(),
    };
  },
  mounted() {

  },
  methods: {
    getDateTime: function (timestamp) {
      var date = new Date
      console.log(this.data.offset_time)
      date.setTime(timestamp + (this.data.offset_time * 60 * 60 * 1000))
      return zero_in_start(date.getUTCDate()) + '-' + zero_in_start(date.getUTCMonth()+1) + '-' + date.getUTCFullYear() + ' ' +
        date.getUTCHours() + ':' + zero_in_start(date.getUTCMinutes()) + ':' + zero_in_start(date.getUTCSeconds())
    },
    getStatusText: function (data) {
      return get_status_text(this, data)
    },
    isAlarm: function (status) {
      var alert_statuses = [1, 10, 14]
      if (alert_statuses.indexOf(status) != -1) {
        return true
      } else {
        return false
      }
    },
    changeDatasetSlice: function () {
      if (this.pagination_index < 0) {
        this.pagination_index = 0
      }

      if (this.count_view_rows > this.dataset.length) {
        console.log(this.dataset.length)
        this.view_slice = this.dataset
      } else {
        var slice_index = this.pagination_index + 1
        var final_index = this.count_view_rows * slice_index
        var start_index = final_index - this.count_view_rows
        if (final_index > this.dataset.length) {
          final_index = this.dataset.length
        }
        if (start_index < 0) {
          start_index = 0
        }
        this.view_slice = this.dataset.slice(start_index, final_index)
      }
    },
    changePagination: function (page, range) {
      console.log(page)
      this.pagination_index = page
      this.changeDatasetSlice()
    }
  },
  watch: {
    dataset: function (new_dataset, old_dataset) {
      if (new_dataset != old_dataset) {
        this.pagination_total = new_dataset.length / this.count_view_rows + 1

        // this.pagination = Array.apply(null, {
        //   length: count_pagination_slices
        // }).map(function (value, index) {
        //   return index + 1;
        // })
      }
    }
  },
  computed: {
    total_items: function () {
      return this.dataset.length
    }
  },
  props: ['data']
}

function get_for_history(vue_obj) {
  if (!!localStorage.token) {
    console.log(vue_obj.data)
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('sensors', vue_obj.data.sensors)
    post_data.set('faucets', vue_obj.data.faucets)
    post_data.set('period_start', vue_obj.data.start_time)
    post_data.set('period_end', vue_obj.data.end_time)
    if (localStorage.debug_status) {
        post_data.set('debug', true)
    }
    axios({
        method: 'POST',
        url: config.API_HOST + '/groups/get_for_history_doing',
        data: post_data
      })
      .then(function (response) {
        vue_obj.pagination_index = 0
        vue_obj.faucets = response.data.faucets
        vue_obj.sensors = response.data.sensors
        vue_obj.dataset = response.data.dataset
        vue_obj.loader = false
        vue_obj.changeDatasetSlice()
      })
      .catch(function (error) {
        console.log(error)
        console.log(error.response)
        // get_for_chart(vue_obj)
      })
  }
}

function get_status_text(vue_obj, data) {
  if (data[2] == 1) {
    var sensor_name = vue_obj.sensors[data[1]]
    if (sensor_name) {
      return 'Датчик "' + sensor_name + '" перешел в режим тревоги'
    }
  } else if (data[2] == 2) {
    var sensor_name = vue_obj.sensors[data[1]]
    if (sensor_name) {
      return 'Датчик "' + sensor_name + '" перешел в режим нормальной работы'
    }
  } else if (data[2] == 3) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" подключил внешнее питание'
    }
  } else if (data[2] == 4) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" отключил внешнее питание'
    }
  } else if (data[2] == 5) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Низкий заряд батареи крана - "' + faucet_name + '"'
    }
  } else if (data[2] == 6) {
    var faucet_name = vue_obj.faucets[data[0]]
    var faucet_text = ''
    if (faucet_name) {
        faucet_text = ' - "' + faucet_name + '"'
    }
    return data[3] + faucet_text
  } else if (data[2] == 7) {
    var sensor_name = vue_obj.sensors[data[1]]
    if (sensor_name) {
      return 'Низкий заряд батареи датчика - "' + sensor_name + '"'
    }
  } else if (data[2] == 8) {
    var sensor_name = vue_obj.sensors[data[1]]
    if (sensor_name) {
      return 'Добавили датчик - "' + sensor_name + '"'
    }
  } else if (data[2] == 10) {
    return 'Было отправлено уведомление о тревоге'
  } else if (data[2] == 11) {
    return 'Было отправлено уведомление о снятии тревоги'
  } else if (data[2] == 12) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" перешел в состояние ОТКРЫТО'
    }
  } else if (data[2] == 13) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" перешел в состояние ЗАКРЫТО'
    }
  } else if (data[2] == 14) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" перешел в состояние ОШИБКА'
    }
  } else if (data[2] == 15) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" в режиме АВТО'
    }
  } else if (data[2] == 16) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" в режиме РУЧНОЙ'
    }
  } else if (data[2] == 17) {
    var faucet_name = vue_obj.faucets[data[0]]
    if (faucet_name) {
      return 'Кран "' + faucet_name + '" в режиме РАСПИСАНИЕ'
    }
  }
  return ''
}

function get_utc_difference() {
  var date = new Date;
  var utc_date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  return Math.floor(date.getTime() - utc_date.getTime())
}

function zero_in_start(number) {
  if (number >= 0 && number <= 9) {
    return '0' + number
  } else {
    return number
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/history_statuses.vue